import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@gettactic/components';
import {
  ArrowDown,
  ArrowUp,
  Crosshair,
  Group,
  MoreVertical,
  Square,
  Trash2,
  Ungroup
} from 'lucide-react';
import React from 'react';

interface LayerActionsProps {
  onDelete?: () => void;
  onLocate?: () => void;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
  onUngroup?: () => void;
  onGroup?: () => void;
  onUpdateEditingArea?: () => void;
}

export const LayerActions: React.FC<LayerActionsProps> = ({
  onDelete,
  onLocate,
  onMoveUp,
  onMoveDown,
  onGroup,
  onUngroup,
  onUpdateEditingArea
}) => {
  const handleAction = (action: () => void) => {
    action();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="p-1 rounded hover:bg-gray-200 transition-colors text-gray-600"
          title="More actions"
        >
          <MoreVertical size={16} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuGroup>
          {onMoveUp && (
            <DropdownMenuItem
              className={'gap-2'}
              onClick={(e) => {
                e.stopPropagation();
                handleAction(onMoveUp);
              }}
            >
              <ArrowUp size={14} className="text-gray-500" />
              Move Up
            </DropdownMenuItem>
          )}
          {onMoveDown && (
            <DropdownMenuItem
              className={'gap-2'}
              onClick={(e) => {
                e.stopPropagation();
                handleAction(onMoveDown);
              }}
            >
              <ArrowDown size={14} className="text-gray-500" />
              Move Down
            </DropdownMenuItem>
          )}
          {onLocate && (
            <DropdownMenuItem
              className={'gap-2'}
              onClick={(e) => {
                e.stopPropagation();
                handleAction(onLocate);
              }}
            >
              <Crosshair size={14} className="text-blue-500" />
              Locate
            </DropdownMenuItem>
          )}
          {onDelete && (
            <DropdownMenuItem
              className={'gap-2'}
              onClick={(e) => {
                e.stopPropagation();
                handleAction(onDelete);
              }}
            >
              <Trash2 size={14} className="text-red-500" />
              Delete
            </DropdownMenuItem>
          )}
          {onGroup && (
            <>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                className={'gap-2'}
                onClick={(e) => {
                  e.stopPropagation();
                  handleAction(onGroup);
                }}
              >
                <Group size={14} className="text-blue-500" />
                Group items
              </DropdownMenuItem>
            </>
          )}
          {onUngroup && (
            <>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                className={'gap-2'}
                onClick={(e) => {
                  e.stopPropagation();
                  handleAction(onUngroup);
                }}
              >
                <Ungroup size={14} className="text-red-500" />
                Ungroup
              </DropdownMenuItem>
            </>
          )}
          {onUpdateEditingArea && (
            <>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                className={'gap-2'}
                onClick={(e) => {
                  e.stopPropagation();
                  handleAction(onUpdateEditingArea);
                }}
              >
                <Square size={14} className="text-green-500" />
                Update editing area
              </DropdownMenuItem>
            </>
          )}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
